const state = {
  currentUser: null,
};

const getters = {
  currentUser: (state) => state.currentUser,
  currentUsername: (state) =>
    state.currentUser ? state.currentUser.username : null,
  currentUserIndex: (state) =>
    state.currentUser ? state.currentUser.index : null,
  currentUserInfos: (state) =>
    state.currentUser && state.currentUser.content
      ? state.currentUser.content
      : null,
};

const actions = {
  LOGIN: async ({ commit, dispatch }, { credentials, kuzzle }) => {
    commit('app/SET_LOADING', null, { root: true });
    let jwt;
    try {
      jwt = await kuzzle.auth.login('local', credentials, '7 days');
      await dispatch('FETCH_CURRENT_USER', kuzzle);
    } catch (error) {
      localStorage.removeItem('user_token');
      commit('app/UNSET_LOADING', null, { root: true });
      throw error;
    }

    localStorage.setItem('user_token', jwt);
    commit('app/UNSET_LOADING', null, { root: true });
  },
  CHECK_TOKEN: async ({ dispatch, getters }, kuzzle) => {
    const jwt = localStorage.getItem('user_token');

    if (!jwt) {
      return false;
    }

    const { valid } = await kuzzle.auth.checkToken(jwt);

    if (!valid) {
      await dispatch('LOG_OUT', kuzzle);
      return false;
    }

    kuzzle.jwt = jwt;

    if (!getters.currentUser) {
      await dispatch('FETCH_CURRENT_USER', kuzzle);
    }

    return true;
  },
  FETCH_CURRENT_USER: async ({ commit, dispatch }, kuzzle) => {
    let currentUser;
    try {
      const rights = await kuzzle.auth.getMyRights();
      const right = rights.find(
        (r) => r.controller === 'document' && r.collection === 'paths'
      );
      const index = right.index;

      currentUser = await kuzzle.auth.getMyCredentials('local');
      //console.log('currentuser', currentUser, rights, index);
      currentUser.index = index;
      currentUser.loggedAsUser = null;
      if (currentUser.loggedAsUser !== null) {
        console.log('currentUser.loggedAsUser', currentUser.loggedAsUser);
      }
      currentUser.content = await kuzzle.auth
        .getCurrentUser()
        .then((response) => response.content);
      currentUser.isAdmin =
        currentUser.content.profileIds.includes('superadmin');

      // FETCH PATHS MISSIONS AND SITE IN STORE
      await dispatch(
        'accounts/FETCH_ACCOUNT',
        { kuzzle, index },
        { root: true }
      );
      await dispatch('paths/FETCH_PATHS', { kuzzle, index }, { root: true });
      await dispatch(
        'paths/FETCH_PROMOCODES',
        { kuzzle, index },
        { root: true }
      );
      await dispatch(
        'missions/FETCH_MISSIONS',
        { kuzzle, index },
        { root: true }
      );
      await dispatch(
        'infosheets/FETCH_INFOSHEETS',
        { kuzzle, index },
        { root: true }
      );
      await dispatch('stats/FETCH_STATS', { kuzzle, index }, { root: true });
      // await dispatch('stats/FETCH_STATS_FEATURES', { kuzzle }, { root: true });
      await dispatch('accounts/SUBSCRIBE', { kuzzle, index }, { root: true });
      await dispatch('paths/SUBSCRIBE', { kuzzle, index }, { root: true });
      await dispatch('missions/SUBSCRIBE', { kuzzle, index }, { root: true });
      await dispatch('infosheets/SUBSCRIBE', { kuzzle, index }, { root: true });
      await dispatch('stats/SUBSCRIBE', { kuzzle, index }, { root: true });
      //await dispatch('stats/SUBSCRIBE_FEATURES', { kuzzle }, { root: true });
    } catch (error) {
      throw error;
    }
    commit('SET_CURRENT_USER', currentUser);
  },

  LOG_OUT: async ({ commit, dispatch }, kuzzle) => {
    commit('UNSET_CURRENT_USER');
    commit('account/UNSET_CURRENT_ACCOUNT', null, { root: true });
    await dispatch('paths/UNSUBSCRIBE', kuzzle, { root: true });
    await dispatch('infosheets/UNSUBSCRIBE', kuzzle, { root: true });
    await dispatch('missions/UNSUBSCRIBE', kuzzle, { root: true });
    await dispatch('accounts/UNSUBSCRIBE', kuzzle, { root: true });
    await dispatch('stats/UNSUBSCRIBE', kuzzle, { root: true });
    await dispatch('stats/UNSUBSCRIBE_FEATURES', kuzzle, { root: true });
    commit('paths/RESET_PATHS', null, { root: true });
    commit('infosheets/RESET_INFOSHEETS', null, { root: true });
    commit('missions/RESET_MISSIONS', null, { root: true });
    commit('accounts/RESET_ACCOUNT', null, { root: true });
    commit('stats/RESET_STATS', null, { root: true });
    commit('stats/RESET_STATS_FEATURES', null, { root: true });

    kuzzle.jwt = null;
    localStorage.removeItem('user_token');
  },
  SAVE_USER_LOCALE: async ({ commit }, { locale, kuzzle }) => {
    try {
      await kuzzle.auth.updateSelf({ locale });
      commit('SET_USER_LOCALE', locale);
    } catch (error) {
      console.error(
        `Unable to set locale ${locale} for current user: ${error.message}`
      );
    }
  },
  UPDATE_USER: async ({ commit }, { userPayload, kuzzle }) => {
    await kuzzle.auth.updateSelf(userPayload);
    //commit('RESET_USER_CONTENT');
    commit('UPDATE_USER', userPayload);
  },
  UPDATE_USER_CREDENTIALS: async ({ commit }, { userPayload, kuzzle }) => {
    await kuzzle.auth.updateMyCredentials('local', userPayload);
    commit('RESET_USER_CREDENTIALS');
    commit('UPDATE_USER_CREDENTIALS', userPayload);
  },
};

const mutations = {
  SET_CURRENT_USER: (state, user) => {
    state.currentUser = user;
  },
  UNSET_CURRENT_USER: (state) => {
    state.currentUser = null;
  },
  SET_USER_LOCALE: (state, locale) => {
    if (!state.currentUser || !state.currentUser.content) {
      return;
    }
    if (!locale) {
      return;
    }

    state.currentUser.content.locale = locale;
  },
  RESET_USER_CONTENT: (state) => {
    state.currentUser.content = null;
  },
  RESET_USER_CREDENTIALS: (state) => {
    state.currentUser.username = null;
  },
  UPDATE_USER: (state, userPayload) => {
    Object.entries(userPayload).map(([k, v]) => {
      state.currentUser.content[k] = v;
      return state.currentUser.content;
    });
  },
  UPDATE_USER_CREDENTIALS: (state, userPayload) => {
    state.currentUser = {
      ...state.currentUser,
      username: userPayload.username,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
